import React, {useEffect} from 'react';
import { useTranslation } from "react-i18next";
import styles from './master-create-study.module.scss'
import {Outlet} from "react-router-dom";
import close from "../../../images/master-plan-close.svg";
import {useAppDispatch} from "../../../hooks/useAppDispatch";
import {resetStudyCreationState} from "../../../services/reducers/master-create-study";

const MasterCreateStudy = () => {
    const { t } = useTranslation();
    const todayDate = new Date();
    const formattedDate = todayDate.toLocaleDateString("en-GB");
    const dispatch = useAppDispatch();

    useEffect(() => {
        return () => {
            dispatch(resetStudyCreationState())
        }
    }, []);

    return (
        <div className={styles.masterCreateStudy}>
            <div className={styles.header}>
                <span className={styles.title}>{t('master-create-study.title')}</span>
                <p className={styles.curDate}>{t('master-create-study.datePrefix')}{formattedDate}</p>
                <button className={styles.closeBtn}>
                    <img src={close} alt={t('master-create-study.closeAlt')}/>
                </button>
            </div>
            <div className={styles.content}>
                <Outlet/>
            </div>
        </div>
    );
};

export default MasterCreateStudy;
